import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=0ebdf6d7&isComponent&outputPath=components%2Findex37cd7d2c%2Findex"
import script from "./index.mpx?vue&type=script&lang=ts&isComponent&outputPath=components%2Findex37cd7d2c%2Findex"
export * from "./index.mpx?vue&type=script&lang=ts&isComponent&outputPath=components%2Findex37cd7d2c%2Findex"
import style0 from "./index.mpx?vue&type=style&index=0&id=0ebdf6d7&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_37cd7d2c%22%7D&isComponent&outputPath=components%2Findex37cd7d2c%2Findex"


/* normalize component */
import normalizer from "!../../../../../example/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports